import { Modal } from 'antd';
import { workSpaceSelectors } from 'containers/App/selectors';
import moment from 'moment';
import { getStatusBill, updateStatusBill } from 'pages/Dashboard/thunks';
import { FC, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

type Props = {
  visible: boolean;
  eventActive: (visible: boolean) => void;
};

const ModalUpdateBill: FC<Props> = ({ visible, eventActive }) => {
  const [loading, setLoading] = useState(false);

  const { statusBill } = useSelector(workSpaceSelectors);

  const dispatch = useDispatch();

  const handleSubmit = async () => {
    setLoading(true);
    await dispatch(
      updateStatusBill({
        i_id: statusBill?.i_id,
        curYear: moment().subtract(1, 'M').format('YYYY'),
        monthCur: moment().subtract(1, 'M').format('MM'),
      }),
    );
    await dispatch(getStatusBill());
    eventActive(false);
    setLoading(false);
  };

  return (
    <Modal
      style={{ paddingBottom: 0 }}
      title="請求書を確定する"
      centered
      closable={false}
      visible={visible}
      onOk={handleSubmit}
      confirmLoading={loading}
      onCancel={() => eventActive(false)}
      okText="OK"
      cancelText="キャンセル"
    >
      <p className="standardBoldFont" style={{ textAlign: 'center' }}>
        {moment().subtract(1, 'M').format('YYYY年MM月')}度の請求書を確定します。
        <br />
        確定後は変更ができなくなります。よろしいでしょうか？
      </p>
    </Modal>
  );
};
export default ModalUpdateBill;
